/**
 * "Pause left" on the Sessions page — how much of the pause window a
 * customer still has. It counts down only while they are AWAY.
 *
 * 🔴 It used to floor whole days: a 7-day window with 38 minutes spent read
 * "6d left" next to an identical voucher reading "7d left", and an operator
 * reported the two as getting different validity (khzwn LaDo WiFi,
 * 2026-09-14). Days now carry their hours, so 6 days 23 hours reads as
 * exactly that.
 */
export function formatPauseLeft(msLeft: number): string {
   if (msLeft <= 0) return 'used up';
   const mins = Math.floor(msLeft / 60_000);
   if (mins < 60) return `${Math.max(1, mins)}m left`;
   const hrs = Math.floor(mins / 60);
   if (hrs < 48) {
      const rem = mins % 60;
      return rem > 0 ? `${hrs}h ${rem}m left` : `${hrs}h left`;
   }
   const days = Math.floor(hrs / 24);
   const remH = hrs % 24;
   return remH > 0 ? `${days}d ${remH}h left` : `${days}d left`;
}
